import { z } from "zod";

export const PayexpressMethodType = z.union([
  z.literal("BOTH"),
  z.literal("DECREASE"),
  z.literal("INCREASE"),
  z.literal("STANDARD"),
]);

export type PayexpressMethodType = z.infer<typeof PayexpressMethodType>;
